const { alert } = require('site/components/alerts');
// DOM Elements
$(document).ready(() => {
    const wineModalOverlay = document.getElementById('wineModalOverlay');
    const wineModalClose = document.getElementById('wineModalClose');
    const wineMarketingForm = document.getElementById('wineMarketingForm');
    const wineEmailInput = document.getElementById('wineEmail');
    const winePhoneInput = document.getElementById('winePhone');
    const wineEmailError = document.getElementById('wineEmailError');
    const winePhoneError = document.getElementById('winePhoneError');
    const wineUnlockOfferBtn = document.getElementById('wineUnlockOfferBtn');
    const wineFormContainer = document.getElementById('wineFormContainer');
    const wineSuccessContainer = document.getElementById('wineSuccessContainer');
    const wineTextSignupSection = document.querySelector('.wine-text-signup'); // Add reference to text signup section
    const wineNoThanks = document.getElementById('wineNoThanks');
    const wineTextSignupBtn = document.getElementById('wineTextSignupBtn');
    const wineTextMessageModal = document.getElementById('wineTextMessageModal');

    // Cookie functions
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `; expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value}${expires}; path=/`;
    }

    function getCookie(name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Hide modal and store session info
    function hideModal() {
        wineModalOverlay.classList.remove('wine-is-visible');
        document.body.style.overflow = ''; // Restore scrolling

        // Store in session storage that user has dismissed the modal
        sessionStorage.setItem('wineOptInDismissed', 'true');

        // Reset to form view after modal is closed
        setTimeout(() => {
            wineFormContainer.style.display = 'block';
            wineSuccessContainer.classList.remove('wine-visible');
        }, 300);
    }

    // Check if user has already dismissed or completed the modal
    const hasCompletedForm = getCookie('wineOptInCompleted');
    const hasDismissedModal = sessionStorage.getItem('wineOptInDismissed');

    if (!wineModalOverlay) {
        return; // Exit if modal overlay is not found
    }

    // Unlock offer button shows the modal
    wineUnlockOfferBtn.addEventListener('click', () => {
        // Check if another modal is open by looking for modal-open class on body
        if (!document.body.classList.contains('modal-open')) {
            wineModalOverlay.classList.add('wine-is-visible');
            document.body.style.overflow = 'hidden';
        }
    });

    // No thanks link
    wineNoThanks.addEventListener('click', (e) => {
        e.preventDefault();
        hideModal();
    });

    // Text signup button (for mobile only)
    if (wineTextSignupBtn) {
        wineTextSignupBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const textNumber = wineTextSignupBtn.getAttribute('data-number') || '';
            const textBody = wineTextSignupBtn.getAttribute('data-text') || '';
            window.location.href = `sms:${textNumber}&body=${textBody}`;
        });
    }

    // Close button click
    wineModalClose.addEventListener('click', hideModal);

    // Add touchstart event for better mobile responsiveness, especially on Safari
    wineModalClose.addEventListener('touchstart', (e) => {
        e.preventDefault(); // Prevent default touch behavior
        hideModal();
    });

    // Close when clicking outside the modal
    wineModalOverlay.addEventListener('click', (e) => {
        if (e.target === wineModalOverlay) {
            hideModal();
        }
    });

    // Close text modal when clicking outside
    window.addEventListener('click', (e) => {
        if (wineTextMessageModal && wineTextMessageModal.classList.contains('wine-visible') && !wineTextMessageModal.contains(e.target) && e.target !== wineTextSignupBtn) {
            wineTextMessageModal.classList.remove('wine-visible');
        }
    });

    // Escape key to close
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            if (wineModalOverlay.classList.contains('wine-is-visible')) {
                hideModal();
            }
            if (wineTextMessageModal && wineTextMessageModal.classList.contains('wine-visible')) {
                wineTextMessageModal.classList.remove('wine-visible');
            }
        }
    });

    // Show success message with device-aware display
    function showSuccessMessage() {
        wineFormContainer.style.display = 'none';
        wineSuccessContainer.classList.add('wine-visible');

        // If phone number was already provided, hide the text signup completely
        if (winePhoneInput.value && winePhoneInput.value.trim() !== '') {
            wineTextSignupSection.style.display = 'none';
            return;
        }

        wineTextSignupSection.style.display = 'flex';
    }

    // Email validation function
    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    // Phone validation function
    function validatePhone(phone) {
        // Check if empty (which is valid since it's optional)
        if (!phone.trim()) return true;

        // Allow a US phone number format (xxx-xxx-xxxx)
        // This uses a more specific regex since we're enforcing formatting
        const re = /^(\d{3}-\d{3}-\d{4})$/;
        return re.test(phone);
    }

    function formatPhoneNumber(value) {
        if (!value) return value;
        // Clean input of all non-digit characters
        const phoneNumber = value.replace(/[^\d]/g, '');
        var formattedNumber = phoneNumber;

        // Format based on length
        const phoneNumberLength = phoneNumber.length;

        if (phoneNumberLength < 4) {
            formattedNumber = phoneNumber;
        } else if (phoneNumberLength < 7) {
            formattedNumber = `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
        } else {
            formattedNumber = `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
        }

        return formattedNumber;
    }

    function deformatPhoneNumber(value) {
        if (!value) return value;
        const usCountryPhoneCode = '1';
        const phoneNumber = value.replace(/[^\d]/g, '');
        return `${usCountryPhoneCode}${phoneNumber}`;
    }

    // Input validation on blur
    wineEmailInput.addEventListener('blur', () => {
        if (wineEmailInput.value && !validateEmail(wineEmailInput.value)) {
            wineEmailInput.classList.add('wine-error');
            wineEmailError.classList.add('wine-visible');
        } else {
            wineEmailInput.classList.remove('wine-error');
            wineEmailError.classList.remove('wine-visible');
        }
    });

    // Phone input event listeners for real-time formatting
    winePhoneInput.addEventListener('input', (e) => {
        const cursorPosition = e.target.selectionStart;
        const previousValue = e.target.value;

        // Format the phone number
        const formattedValue = formatPhoneNumber(e.target.value);
        e.target.value = formattedValue;

        // Adjust cursor position if needed
        if (previousValue !== formattedValue) {
            // Count how many additional characters were added by formatting
            const additionalChars = formattedValue.length - previousValue.replace(/[^\d]/g, '').length;

            // Adjust cursor position to account for added formatting characters
            const newPosition = cursorPosition + additionalChars;
            e.target.setSelectionRange(newPosition, newPosition);
        }
    });

    // Phone input validation on blur
    winePhoneInput.addEventListener('blur', () => {
        if (winePhoneInput.value) {
            const value = winePhoneInput.value.trim();
            if (value && !validatePhone(value)) {
                winePhoneInput.classList.add('error');
                winePhoneError.classList.add('visible');
                return;
            }
            winePhoneInput.classList.remove('error');
            winePhoneError.classList.remove('visible');
            return;
        }
        // Empty is valid (optional field)
        winePhoneInput.classList.remove('wine-error');
        winePhoneError.classList.remove('wine-visible');
    });

    // Get the terms checkbox and error elements
    const wineTermsCheckbox = document.getElementById('wineTerms');
    const wineTermsError = document.getElementById('wineTermsError');

    // Subscribe Now button handler
    const wineSubscribeNowBtn = document.getElementById('wineSubscribeNowBtn');
    if (wineSubscribeNowBtn) {
        wineSubscribeNowBtn.addEventListener('click', (e) => {
            e.preventDefault();

            let isValid = true;

            // Email validation
            if (!validateEmail(wineEmailInput.value)) {
                wineEmailInput.classList.add('wine-error');
                wineEmailError.classList.add('wine-visible');
                isValid = false;
            } else {
                wineEmailInput.classList.remove('wine-error');
                wineEmailError.classList.remove('wine-visible');
            }

            // Phone validation (if provided)
            if (winePhoneInput.value && !validatePhone(winePhoneInput.value)) {
                winePhoneInput.classList.add('wine-error');
                winePhoneError.classList.add('wine-visible');
                isValid = false;
            } else {
                winePhoneInput.classList.remove('wine-error');
                winePhoneError.classList.remove('wine-visible');
            }

            // Terms checkbox validation
            if (wineTermsCheckbox && !wineTermsCheckbox.checked) {
                // Add error styling for checkbox
                wineTermsCheckbox.classList.add('wine-error');
                // Show error message if it exists
                if (wineTermsError) {
                    wineTermsError.classList.add('wine-visible');
                }
                isValid = false;
            } else if (wineTermsCheckbox) {
                wineTermsCheckbox.classList.remove('wine-error');
                if (wineTermsError) {
                    wineTermsError.classList.remove('wine-visible');
                }
            }

            if (isValid) {
                const updatedPhoneNumber = deformatPhoneNumber(winePhoneInput.value);
                const url = wineMarketingForm.getAttribute('action');
                const errorMsg = { message: 'For technical reasons, your request could not be handled properly at this time. We apologize for any inconvenience.' };
                $.ajax({
                    url,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        email: wineEmailInput.value,
                        phone: updatedPhoneNumber,
                    },
                    success: (data) => {
                        if (data.success) {
                            // Show success message
                            showSuccessMessage();
                            wineMarketingForm.reset();
                            // Set cookie when form is successfully submitted (7 days)
                            setCookie('wineOptInCompleted', 'true', 7);
                        } else {
                            alert({ message: data.message });
                        }
                    },
                    error: () => {
                        // Handle error
                        alert(errorMsg);
                    },
                });
            }
        });
    }

    // Function to check if other modals are open and display wine modal if not
    function checkAndShowModal() {
        if (wineUnlockOfferBtn && !document.body.classList.contains('modal-open')) {
            wineUnlockOfferBtn.click(); // Trigger the unlock offer button click
        }
    }

    // Auto-trigger popup based on data attribute delay and only if not seen/completed before
    let delay = 5000; // Default 5 seconds
    if (wineModalOverlay && wineModalOverlay.dataset.showDelay) {
        delay = parseInt(wineModalOverlay.dataset.showDelay, 10) || 5000;
    }

    // Only show the modal if user hasn't completed the form or dismissed it this session
    if (!hasCompletedForm && !hasDismissedModal) {
        // Initial delay before first check
        setTimeout(() => {
            checkAndShowModal();

            // Set up periodic checks every 5 seconds
            const modalCheckInterval = setInterval(() => {
                // If modal is already visible or user has dismissed/completed, stop checking
                if (wineModalOverlay.classList.contains('wine-is-visible')
                    || getCookie('wineOptInCompleted')
                    || sessionStorage.getItem('wineOptInDismissed')) {
                    clearInterval(modalCheckInterval);
                } else {
                    checkAndShowModal();
                }
            }, 5000);
        }, delay);
    }
});
